import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loading: false,
    hardLoading: false,
    loadingMessage: '',
    region: [],
    orderStatus: [],
    toushou: [],
    language: [],
    domain: [],
    authorityList: JSON.parse(localStorage.getItem('authorityList')||'[]'),
    userData: JSON.parse(localStorage.getItem('userData')||'{}'),
    accountPageStatusList: []
  },
  mutations: {
    SET_LOADING (state, res) {
      state.loading = res
    },
    SET_HARD_LOADING (state, res) {
      state.hardLoading = res
    },
    SET_REGION (state, res) {
      state.region = res
    },
    SET_TOUSHOU (state, res) {
      state.toushou = res
    },
    SET_LANGUAGE (state, res) {
      state.language = res
    },
    SET_DOMAIN (state, res) {
      state.domain = res
    },
    SET_ORDER_STATUS (state, res) {
      state.orderStatus = res
    },
    SET_AUTHORITY (state, res) {
      state.authorityList = res
    },
    SET_LOADING_MESSAGE (state, res) {
      state.loadingMessage = res
    },
    SET_USERDATA (state, res) {
      state.userData = res
    },
    SET_ACCOUNT_PAGE_STATUS (state, res) {
      state.accountPageStatusList = res
    },
  },
  actions: {
  },
  modules: {
  },
});
